import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SocialMediaGetService } from '../../services';

export const fetchSocialMediaGet = createAsyncThunk(
    'socialMediaGet/fetchSocialMediaGet',
    async ({ id }) => {
        const response = await SocialMediaGetService(id)
        return response.result
    }
);

const socialMediaGetSlice = createSlice({
    name: 'socialMediaGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSocialMediaGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSocialMediaGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSocialMediaGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default socialMediaGetSlice.reducer;
